import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, forwardRef, Inject, ElementRef, ViewChild } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators} from "@angular/forms";
import {DadosPessoaisAba1Response} from "../../auth/_models/DadosPessoaisAba1";
import {EnumService} from "../../service/enum/enum";
import {ToastrService} from "ngx-toastr";
import {DocumentosPessoaisAba3Service} from "../../service/documentos-pessoais-aba3/documentos-pessoais-aba3.service";
import {DocumentosPessoaisDto} from "./documentosPessoais.dto";
import {CategoriasCnhDto} from "../../model/categoriasCnh.dto";
import {LocalidadesIbgeService} from "../../service/localidades-ibge/localidades-ibge.service";
import {Ufs} from "../../model/Ufs";
import {OrgaoEmissorDto} from "../../model/orgaoEmissor";
import * as moment from 'moment';
import { saveAs } from 'file-saver';
import 'moment/locale/pt';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-recadastramento-aba3',
  templateUrl: './recadastramento-aba3.component.html',
  styleUrls: ['./recadastramento-aba3.component.sass']
})
export class RecadastramentoAba3Component implements OnInit, OnChanges {

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild('fileInputRg') fileInputRg!: ElementRef;
  @ViewChild('fileInputCnh') fileInputCnh!: ElementRef;
  @ViewChild('fileInputTitulo') fileInputTitulo!: ElementRef;

  form: FormGroup;
  user: DadosPessoaisAba1Response = null;
  uf: string;
  isInfoImportantVisible: boolean = true;
  arquivoSelecionadoRg: File;
  arquivoSelecionadoCnh: File;
  arquivoSelecionadoTitulo: File;
  documentos: DocumentosPessoaisDto = new DocumentosPessoaisDto();
  categoriasCnh: CategoriasCnhDto[];
  ufs: Ufs[];
  orgaoEmissor: OrgaoEmissorDto[];
  flFileRg: boolean;
  flFileCnh: boolean;
  flFileTitulo: boolean;
  existAnexoRg: boolean = true;
  existAnexoCnh: boolean = true;
  existAnexoTitulo: boolean = true;
  existDiffCnh: boolean = false;
  existDiffRg: boolean = false;
  existDiffTitulo: boolean = false;
  isLoadingSpinner: boolean = true;
  flTemCnh: boolean = false;
  isLoadingFileRg: boolean = false;
  isLoadingFileCnh: boolean = false;
  isLoadingFileTitulo: boolean = false;
  hideAlertRg: boolean = false;
  hideAlertCnh: boolean = false;
  hideAlertTitulo: boolean = false;

  constructor(
      private documentosPessoaisAba3Service: DocumentosPessoaisAba3Service,
      private enumService: EnumService,
      private localidadesIbgeService: LocalidadesIbgeService,
      private toasterService: ToastrService,
      private formBuilder: FormBuilder,
      private datePipe: DatePipe
     ) {
  }

  ngOnInit(): void {
      this.form = this.formBuilder.group({
          numeCartIdent: [''],
          descOrgaoEmissaoRg: [''],
          codgUfRG: [''],
          dataExpedicaoRg: [''],
          numeCnh: [''],
          descCatgCnh: [''],
          dataVencCnh: [''],
          dataExpedCnh: [''],
          ufCnh: [''],
          dataPrimeiraCnh: [''],
          numeTituloEleitor: [''],
          codgUfTituloEleitor: [''],
          numeZonaTitEleitor: [''],
          numeSecaoTitEleitor: [''],
          descOrgaoClasse: [''],
          numeCartConsReg: [''],
          dataEmisCartConsReg: [''],
          codgUfCartConsReg: ['']
      });
      this.form.get('numeCartConsReg')?.disable();
      this.form.get('dataEmisCartConsReg')?.disable();
      this.form.get('codgUfCartConsReg')?.disable();
      this.form.get('numeCartConsReg')?.disable();
      this.form.get('descOrgaoClasse')?.disable();
      this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
      this.carregadorDadosIniciais();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
        this.isInfoImportantVisible = true
    }
  }

//   transform(date: Date | null): string {
//     if (!date) return '';
//     return formatDate(date, 'dd/MM/yyyy', 'pt-BR', '-03:00'); // Adjust UTC offset according to your timezone
//   }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

    toggleInfoImportantVisibleTitulo() {
        this.hideAlertTitulo = !this.hideAlertTitulo;
    }
    toggleInfoImportantVisibleRg() {
        this.hideAlertRg = !this.hideAlertRg;
    }
    toggleInfoImportantVisibleCnh() {
        this.hideAlertCnh = !this.hideAlertCnh;
    }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

  private carregadorDadosIniciais() {
      this.isLoadingSpinner = true;
    this.getDocumentosPessoias();
    this.getCategoriasCnh();
    this.getUfs();
    this.getOrgaoEmissor();
    //this.getArquivos();
  }

  getArquivos(tipo: string) {

      if(tipo === 'rg'){
          this.documentosPessoaisAba3Service.getArquivos('identidade').subscribe((resp: Blob)=> {
              let blobRg: Blob;
              const fileType = resp.type || 'application/octet-stream';

              let fileName = 'Comprovante_Rg';
              const fileExtension = this.getFileExtensionFromMimeType(fileType);

              if (fileExtension) {
                  fileName += '.' + fileExtension;
              }

              blobRg = new Blob([resp], { type: fileType });
              this.downloadFile(blobRg, fileName);
              //blobRg !== null && undefined ? this.flFileRg = true : this.flFileRg = false;
          });
      }
      if(tipo === 'cnh') {
          this.documentosPessoaisAba3Service.getArquivos('cnh').subscribe((resp: Blob) => {
              let blobCnh: Blob;
              const fileType = resp.type || 'application/octet-stream';

              let fileName = 'Comprovante_Cnh';
              const fileExtension = this.getFileExtensionFromMimeType(fileType);

              if (fileExtension) {
                  fileName += '.' + fileExtension;
              }

              blobCnh = new Blob([resp], { type: fileType });
              this.downloadFile(blobCnh, fileName);
              //this.blobCnh !== null && undefined ? this.flFileCnh = true : this.flFileCnh = false;
          });
      }

      if(tipo === 'titulo') {
          this.documentosPessoaisAba3Service.getArquivos('tituloeleitor').subscribe((resp: Blob) => {
              let blobTitulo: Blob;
              const fileType = resp.type || 'application/octet-stream';

              let fileName = 'Comprovante_Titulo';
              const fileExtension = this.getFileExtensionFromMimeType(fileType);

              if (fileExtension) {
                  fileName += '.' + fileExtension;
              }
              blobTitulo = new Blob([resp], { type: fileType });
              this.downloadFile(blobTitulo, fileName);
              //this.blobTitulo !== null && undefined ? this.flFileTitulo = true : this.flFileTitulo = false;
          });
      }
    }

    private getFileExtensionFromMimeType(mimeType: string): string | null {
        const extensionMap = {
            'application/pdf': 'pdf',
            'image/jpeg': 'jpeg',
            'image/jpg': 'jpg',
            'image/png': 'png'
            // Adicione outras extensões e tipos MIME conforme necessário
        };

        return extensionMap[mimeType] || null;
    }

    downloadFile(blob: Blob, fileName: string): void {
        saveAs(blob, fileName);
        this.toasterService.success('Arquivo baixado com sucesso');
    }

    private getOrgaoEmissor() {
        this.documentosPessoaisAba3Service.getTiposOrgaoEmissor().subscribe(resp => {
            this.orgaoEmissor = resp;
        })
    }

    private getUfs() {
        this.ufs = this.localidadesIbgeService.getUfs();
    }

    private getCategoriasCnh() {
        this.documentosPessoaisAba3Service.getCategoriasCnh().subscribe(resp => {
            this.categoriasCnh = resp
        }, error => {
            console.error(error);
        })
    }

  private getDocumentosPessoias() {
    this.documentosPessoaisAba3Service.getDocumentosPessoais().subscribe(resp => {
      this.documentos = resp;
      if(this.documentos.isAnexoRg){
          this.flFileRg = true;
          this.arquivoSelecionadoRg = new File(new Array<Blob>(), '');
      }
      if(this.documentos.isAnexoCnh){
        this.flFileCnh = true;
        this.arquivoSelecionadoCnh = new File(new Array<Blob>(), '');
      }
      if(this.documentos.isAnexoTituloEleitor){
         this.flFileTitulo = true;
         this.arquivoSelecionadoTitulo = new File(new Array<Blob>(), '');
      }
      let dataExpedicaoRg = this.documentos.dataExpedicaoRg !== null ? this.documentos.dataExpedicaoRg.split('/') : '';
      let dataEmisCartConsReg = this.documentos.dataEmisCartConsReg !== null ? this.documentos.dataEmisCartConsReg.split('/') : '';
      let dataPrimeiraCnh = this.documentos.dataPrimeiraCnh !== null ?this.documentos.dataPrimeiraCnh.split('/') : '';
      let dataExpedCnh = this.documentos.dataExpedCnh !== null ? this.documentos.dataExpedCnh.split('/') : '';
      let dataVencCnh = this.documentos.dataVencCnh !== null ? this.documentos.dataVencCnh.split('/') : '';
      this.form.patchValue(this.documentos);
      dataExpedicaoRg !== '' ? this.form.patchValue({dataExpedicaoRg:  new Date(+dataExpedicaoRg[2], +dataExpedicaoRg[1]-1, +dataExpedicaoRg[0])}) : false;
      dataEmisCartConsReg !== '' ? this.form.patchValue({dataEmisCartConsReg:  new Date(+dataEmisCartConsReg[2], +dataEmisCartConsReg[1]-1, +dataEmisCartConsReg[0])}) : false;
      dataPrimeiraCnh !== '' ? this.form.patchValue({dataPrimeiraCnh:  new Date(+dataPrimeiraCnh[2], +dataPrimeiraCnh[1]-1, +dataPrimeiraCnh[0])}) : false;
      dataExpedCnh !== '' ? this.form.patchValue({dataExpedCnh:  new Date(+dataExpedCnh[2], +dataExpedCnh[1]-1, +dataExpedCnh[0])}) : false;
      dataVencCnh !== '' ? this.form.patchValue({dataVencCnh:  new Date(+dataVencCnh[2], +dataVencCnh[1]-1, +dataVencCnh[0])}) : false;
      this.documentos.numeCnh == null ? this.flTemCnh = false : this.flTemCnh = true;

      this.isLoadingSpinner = false;
    }, error => {
        this.isLoadingSpinner = false;
      console.error(error);
    });
  }


  salvarDocumentos() {
    let flValid: boolean = true;
    let documentosSubmit: DocumentosPessoaisDto = new DocumentosPessoaisDto();
    documentosSubmit = this.form.value;



    documentosSubmit.dataExpedicaoRg = moment(this.form.controls['dataExpedicaoRg'].value).format('DD/MM/YYYY');
    documentosSubmit.dataEmisCartConsReg = moment(this.form.controls['dataEmisCartConsReg'].value).format('DD/MM/YYYY');
    documentosSubmit.dataPrimeiraCnh = moment(this.form.controls['dataPrimeiraCnh'].value).format('DD/MM/YYYY');
    documentosSubmit.dataExpedCnh = moment(this.form.controls['dataExpedCnh'].value).format('DD/MM/YYYY');
    documentosSubmit.dataVencCnh = moment(this.form.controls['dataVencCnh'].value).format('DD/MM/YYYY');

    this.normalizeData(documentosSubmit);

    /*if (this.checkDiffForm()) {
        flValid = false;
    }*/

     if( this.existDiffRg || this.existDiffCnh || this.existDiffTitulo ) {
         if(!this.flFileRg || !this.flFileCnh || !this.flFileTitulo){
            this.toasterService.warning('Anexar comprovante.');
            return;
         }
     }

    if(flValid){
        if (this.form.valid) {
            this.documentosPessoaisAba3Service.salvarDocumentosPessoais(documentosSubmit).subscribe(
                (response) => {
                    this.getDocumentosPessoias();
                    this.toasterService.success('Dados atualizados com sucesso');
                    this.dadosSalvos.emit();
                },
                (error) => {
                    console.error('Erro ao atualizar os dados', error);
                    this.toasterService.error('Erro ao salvar Dados');
                }
            );
        }
    }

  }

 /* checkDiffForm(): boolean {
      let flRg = this.checkDiffRegistroGeral() ;
      let flCnh = this.checkDiffCnh();
      let flTitulo = this.checkDiffTitulo();

      return flRg || flCnh || flTitulo ? true : false;
  }*/

  onArquivoExcluidoRg() {
    this.flFileRg = false;
    //this.arquivoSelecionadoRg = null;
    this.isLoadingFileRg = false;
    this.existAnexoRg = false;
    this.toasterService.success('Arquivo excluído com sucesso');
    if(this.documentos.isAnexoRg){
      this.existDiffRg = true;
    }
  }

    onArquivoExcluidoCnh() {
        this.flFileCnh = false;
        //this.arquivoSelecionadoCnh = null;
        this.isLoadingFileCnh = false;
        this.existAnexoCnh = false
        this.toasterService.success('Arquivo excluído com sucesso');
        if(this.documentos.isAnexoCnh){
            this.existDiffCnh = true;
        }
    }

    onArquivoExcluidoTitulo() {
        //this.arquivoSelecionadoTitulo = null;
        this.flFileTitulo = false;
        this.isLoadingFileTitulo = false;
        this.existAnexoTitulo = false
        this.toasterService.success('Arquivo excluído com sucesso');
        if(this.documentos.isAnexoTituloEleitor){
            this.existDiffTitulo = true;
        }
    }

  onArquivoSelecionado(event: any, TipoDocumento: string) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
        switch (TipoDocumento){
            case 'rg':
                this.isLoadingFileRg = true;
                this.arquivoSelecionadoRg = file;
                this.existAnexoRg = true;
                this.enviarAnexoRg();
                break;
            case 'cnh':
                this.isLoadingFileCnh = true;
                this.arquivoSelecionadoCnh = file;
                this.existAnexoCnh = true;

                this.enviarAnexoCnh();
                break
            case 'titulo':
                this.isLoadingFileTitulo = true;
                this.arquivoSelecionadoTitulo = file;
                this.existAnexoTitulo = true;
                this.enviarAnexoTitulo();
                break
        }

    }
    else {
        this.arquivoSelecionadoRg = null;

        if (!allowedFileTypes.includes(file.type)) {
            this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
        } else if (file.size > maxFileSizeInBytes) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
        }
        this.onArquivoExcluidoRg()
    }
  }

  enviarAnexoRg() {
    if (this.arquivoSelecionadoRg) {
        this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
            timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
        this.documentosPessoaisAba3Service.uploadComprovanteRg(this.arquivoSelecionadoRg).subscribe(
            (response) => {
                this.isLoadingFileRg = false;
                this.flFileRg = true;
                this.existAnexoRg= true;
                this.existDiffRg = false
                this.fileInputRg.nativeElement.value = '';
                this.toasterService.success('Arquivo enviado', '', {
                    timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
                  });
            },
            (error) => {
                this.fileInputRg.nativeElement.value = '';
                if(error.status == 422){
                    this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
                }else{
                    this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`);
                }
                this.onArquivoExcluidoRg()

            }
        );
    }
  }

    enviarAnexoCnh() {
        if (this.arquivoSelecionadoCnh) {
            this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
                timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
              });
            this.documentosPessoaisAba3Service.uploadComprovanteCnh(this.arquivoSelecionadoCnh).subscribe(
                (response) => {
                    this.flFileCnh = true;
                    this.isLoadingFileCnh= false;
                    this.existAnexoCnh = true;
                    this.existDiffCnh = false
                    this.fileInputCnh.nativeElement.value = '';
                    this.toasterService.success('Arquivo enviado', '', {
                        timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
                      });
                },
                (error) => {
                    if(error.status == 422){
                        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
                    }else{
                        this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`);
                    }
                    this.onArquivoExcluidoCnh()

                }
            );
        }
    }

    enviarAnexoTitulo() {
        if (this.arquivoSelecionadoTitulo) {
            this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
                timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
              });
            this.documentosPessoaisAba3Service.uploadComprovanteTitulo(this.arquivoSelecionadoTitulo).subscribe(
                (response) => {
                    this.isLoadingFileTitulo = false;
                    this.flFileTitulo = true;
                    this.existAnexoTitulo = true
                    this.existDiffTitulo = false
                    this.fileInputTitulo.nativeElement.value = '';
                    this.toasterService.success('Arquivo enviado', '', {
                        timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
                      });
                },
                (error) => {
                    this.fileInputTitulo.nativeElement.value = '';
                    if(error.status == 422){
                        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
                    }else{
                        this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`);
                    }
                    this.onArquivoExcluidoTitulo()

                }
            );
        }
    }
    checkDiffRegistroGeral() {
        const numeCartIdentControl = this.form.get('numeCartIdent') as FormControl;
        const value = numeCartIdentControl.value.trim();

        if (value.length < 6) {
          numeCartIdentControl.setErrors({ minlength: true });
        } else {
          numeCartIdentControl.setErrors(null);
        }

        if (!this.compareInputsRg().includes(true)) {

            if(this.documentos.isAnexoRg){
                this.flFileRg = true;
                this.existDiffRg = false;
            } else {
                this.flFileRg = false;
                this.existDiffRg = false;
                this.existAnexoRg = true;
            }

            this.hideAlertRg = true;

        } else {
            this.hideAlertRg = false;
            this.existDiffRg = true;
            this.flFileRg = false;
            this.existAnexoRg = false;
        }
      }

    private compareInputsRg(): boolean[] {
        let listDiff: boolean[] = [];
        let dateform = null;
        typeof this.form.value.dataExpedicaoRg == 'string' ? dateform = this.form.value.dataExpedicaoRg : dateform = moment(this.form.value.dataExpedicaoRg).format('DD/MM/YYYY')

        if (this.documentos.numeCartIdent !== this.form.value.numeCartIdent) {
            listDiff.push(true);
        }

        if (this.documentos.descOrgaoEmissaoRg !== this.form.value.descOrgaoEmissaoRg) {
            listDiff.push(true);
        }

        if (this.documentos.codgUfRG !== this.form.value.codgUfRG) {
            listDiff.push(true);
        }

        if (this.documentos.dataExpedicaoRg !== (this.form.value.dataExpedicaoRg === 'Invalid date' ? null : dateform)) {
            listDiff.push(true);
        }

        return listDiff;
    }

    checkDiffCnh() {
        if (!this.compareInputsCnh().includes(true)) {

            if(this.documentos.isAnexoCnh){
                this.flFileCnh = true;
                this.existDiffCnh = false;
            } else {
                this.flFileCnh = false;
                this.existDiffCnh = false;
                this.existAnexoCnh = true;
            }

            this.hideAlertCnh = true;

        } else {
            this.hideAlertCnh = false;
            this.existDiffCnh = true;
            this.flFileCnh = false;
            this.existAnexoCnh = false;
        }
    }

    private compareInputsCnh(): boolean[] {
        let listDiff: boolean[] = [];
        let dateform1 = null;
        let dateform2 = null;
        let dateform3 = null;
        typeof this.form.value.dataExpedCnh == 'string' ? dateform1 = this.form.value.dataExpedCnh : dateform1 = moment(this.form.value.dataExpedCnh).format('DD/MM/YYYY')
        typeof this.form.value.dataVencCnh == 'string' ? dateform2 = this.form.value.dataVencCnh : dateform2 = moment(this.form.value.dataVencCnh).format('DD/MM/YYYY')
        typeof this.form.value.dataPrimeiraCnh == 'string' ? dateform3 = this.form.value.dataPrimeiraCnh : dateform3 = moment(this.form.value.dataPrimeiraCnh).format('DD/MM/YYYY')

        if (this.documentos.numeCnh != (this.documentos.numeCnh == null && this.form.value.numeCnh == ""? null : this.form.value.numeCnh)) {
            listDiff.push(true);
        }
        if (this.documentos.ufCnh !== this.form.value.ufCnh) {
            listDiff.push(true);
        }
        if (this.documentos.descCatgCnh !== this.form.value.descCatgCnh) {
            listDiff.push(true);
        }
        if (this.documentos.dataExpedCnh !== (this.form.value.dataExpedCnh === 'Invalid date' ? null : dateform1)) {
            listDiff.push(true);
        }
        if (this.documentos.dataVencCnh !== (this.form.value.dataVencCnh === 'Invalid date' ? null : dateform2)) {
            listDiff.push(true);
        }
        if (this.documentos.dataPrimeiraCnh !== (this.form.value.dataPrimeiraCnh === 'Invalid date' ? null : dateform3)) {
            listDiff.push(true);
        }

        return listDiff;
    }

    checkDiffTitulo() {

        if (!this.compareInputsTitulo().includes(true)) {

            if(this.documentos.isAnexoTituloEleitor){
                this.flFileTitulo = true;
                this.existDiffTitulo = false;
            } else {
                this.flFileTitulo = false;
                this.existDiffTitulo = false;
                this.existAnexoTitulo = true;
            }

            this.hideAlertTitulo = true;
        } else {
            this.hideAlertTitulo = false;
            this.existDiffTitulo = true;
            this.flFileTitulo = false;
            this.existAnexoTitulo = false;
        }
    }

    private compareInputsTitulo(): boolean[] {
        let listDiff: boolean[] = [];

        if (this.documentos.numeTituloEleitor != this.form.value.numeTituloEleitor) {
            listDiff.push(true);
        }
        if (this.documentos.numeZonaTitEleitor != this.form.value.numeZonaTitEleitor) {
            listDiff.push(true);
        }
        if (this.documentos.numeSecaoTitEleitor != this.form.value.numeSecaoTitEleitor) {
            listDiff.push(true);
        }
        if (this.documentos.codgUfTituloEleitor !== this.form.value.codgUfTituloEleitor) {
            listDiff.push(true);
        }

        return listDiff;
    }

    normalizeData(documentSubmit: DocumentosPessoaisDto){
      documentSubmit.dataExpedCnh == "Invalid date" ? documentSubmit.dataExpedCnh=null : false;
      documentSubmit.dataExpedicaoRg == "Invalid date" ? documentSubmit.dataExpedicaoRg=null : false;
      documentSubmit.dataVencCnh == "Invalid date" ? documentSubmit.dataVencCnh=null : false;
      documentSubmit.dataPrimeiraCnh == "Invalid date" ? documentSubmit.dataPrimeiraCnh=null : false;
      documentSubmit.dataEmisCartConsReg == "Invalid date" ? documentSubmit.dataEmisCartConsReg=null : false;
    }

    avancaParaProximoTab() {
        this.dadosSalvos.emit()

      }

    validateInput(field: string) {
       this.form.patchValue({ [field]: this.form.controls[field].value });
    }
}
